module.exports = __webpack_public_path__ + "static/media/74.b37df996.png";